const CANCELLED = 'CANCELLED'
const CLOSED = 'CLOSED'
const OPEN = 'OPEN'
const DRAFT = 'DRAFT'

const statuses = [CLOSED, OPEN, CANCELLED, DRAFT]
const excludedStatusesForEmail = [CANCELLED, CLOSED]

const enumStatuses = {
    [CLOSED]: 'Closed',
    [OPEN]: 'Open',
    [CANCELLED]: 'Canceled',
    [DRAFT]: 'Draft',
}

exports.statuses = statuses;
exports.excludedStatusesForEmail = excludedStatusesForEmail;
exports.enumStatuses = enumStatuses;
exports.CANCELLED = CANCELLED;
exports.CLOSED = CLOSED;
exports.OPEN = OPEN;
exports.DRAFT = DRAFT;